import {Type} from '@angular/core';

export const modalContentTypes: { [key: string]: any } = {};

export interface GnModalContentOptions {
  key: string;
  width?: string;
  height?: string;
  top?: string;
}

export function GnModalContent(options: string | GnModalContentOptions) {
  const option = typeof options === 'string' ? {key: options} : options;
  return (target: Type<any>) => {
    modalContentTypes[option.key] = Object.assign({type: target}, option);
    delete modalContentTypes[option.key].key;
  };
}
